import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Link } from 'react-router-dom';
import { Popup } from '../../../Global/Popup';
import { base_url } from '../../../Api/Api';
import { Loader } from '../../../Global/Loader';

import Header from '../../../Global/Header';

const ReplayTicket = (props) => {

    const [state, setState] = useState({
        data: [],
        popup: false,
        textApi: 'پیام شما با موفقیت ارسال شد',
        loader: true,
        loaderApi: false,
        imgUrl: '',
        descriptionValue: '',
        validInput: false
    })

    useEffect(() => {
        setTimeout(() => {
            setState({
                ...state,
                loader: false
            })
        }, 300);
        console.log(props.match.params.id)
    }, [])

    const handleInput = (e, target) => {
        setState({
            ...state,
            [target]: e.target.value.trim().length == 0 ? '' : e.target.value
        })
    }

    const loadFile = (event) => {
        var image = document.getElementById('output');
        image.src = URL.createObjectURL(event.target.files[0]);
        setState({
            ...state,
            imgUrl: image.src
        })
    };

    const deletePictuer = () => {
        var image = document.getElementById('output');
        image.src = '';
        setState({
            ...state,
            imgUrl: ''
        })
    }

    const submitTicket = () => {
        if (state.descriptionValue.length >= 3) {
            setState({
                ...state,
                loaderApi: true
            })
            const headers = {
                "Authorization": JSON.parse(localStorage.getItem('api_key')),
                "content-type": "application/json",
            };
            if (state.imgUrl.length == 0) {
                const data = {
                    ticket_id: props.match.params.id,
                    message: state.descriptionValue
                };
                console.log(data)
                base_url.post(`ticket_reply`, data)
                    .then(resp => {
                        console.log(resp.data)
                        if (resp.data.status = 1) {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'پیام شما با موفقیت ارسال شد',
                                loaderApi: false
                            })
                        } else {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                loaderApi: false
                            })
                        }
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            console.log(error)
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            }
                        }
                    })
            } else {
                const Data = {
                    ticketAttach: state.imgUrl
                };
                var data = new FormData(document.getElementById("form"));
                base_url.post(`ticket_image`, data)
                    .then(response => {
                        console.log(response.data)
                        const data = {
                            ticket_id: props.match.params.id,
                            message: state.descriptionValue,
                            ticketAttach: response.data.ticketAttach
                        };
                        console.log(data)
                        base_url.post(`ticket_reply`, data, {
                            headers: headers
                        })
                            .then(resp => {
                                console.log(resp.data)
                                if (resp.data.status = 1) {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'پیام شما با موفقیت ارسال شد',
                                        loaderApi: false
                                    })
                                } else {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                        loaderApi: false
                                    })
                                }
                            })
                            .catch(error => {
                                if (error.response != undefined) {
                                    console.log(error)
                                    if (error.response.status == 401) {
                                        props.history.push(`/Entrance`)
                                    }
                                }
                            })
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            console.log(error)
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            }
                        }
                    })
            }

        } else {
            setState({
                ...state,
                validInput: true
            })
        }
    }

    const closePopup = () => {
        setState({
            ...state,
            popup: false
        })
        props.history.goBack()
    }

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <Loader
                active={state.loaderApi} />
            <div className={`instructpg ticket create-ticket ${state.loader ? '' : 'active'}`}>
                <Popup
                    active={state.popup}>
                    <h4>{state.textApi}</h4>
                    <div className="btn-base btn-black btn-sircle">
                        <Button
                            variant="contained"
                            onClick={closePopup} >خروج</Button>
                    </div>
                </Popup>
                <Header
                    innerPage={true}
                    title={`ارسال پاسخ`} />
                <div className="body-ticket">

                    <div className="input-form">
                        <TextField
                            id="description"
                            label="متن پیام"
                            multiline
                            rows={3}
                            value={state.descriptionValue}
                            onChange={(e) => handleInput(e, 'descriptionValue')}
                        />
                        <span className={`error-respns ${state.descriptionValue.length <= 3 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                متن پیام خود کامل وارد کنید
                        </span>
                    </div>

                    <div className={`pic-upload ${state.imgUrl.length == 0 ? 'slct-img' : ''}`}>
                        <form className="input-select" id="form">
                            <input
                                type="file"
                                accept="image/*"
                                name="ticketAttach"
                                id="file"
                                onChange={(event) => loadFile(event)} />
                            <div className="detail">
                                <i className="icon-upload"></i>
                                <span>آپلود عکس</span>
                            </div>
                        </form>
                        <div className="selected-pic">
                            <img id="output" src="" />
                            <div className="overlay-delete">
                                <i className="icon-bin" onClick={deletePictuer}></i>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Button
                        variant="contained"
                        onClick={submitTicket} >ارسال</Button>
                </div>

            </div>
        </React.Fragment >
    );
}

export default ReplayTicket;